import React, { useEffect, useRef } from 'react';

/**
 * Animated confetti background with hearts and stars
 * Creates a playful, celebratory atmosphere
 */
export default function Confetti({
    count = 30,
    colors = ['#F4A6C1', '#A8D5BA', '#A7D8F7', '#4AA294', '#FFD93D'],
    shapes = ['heart', 'star', 'circle'],
    speed = 'normal'
}) {
    const containerRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const speedMultiplier = speed === 'slow' ? 1.5 : speed === 'fast' ? 0.7 : 1;

        // Generate confetti pieces
        const confettiPieces = [];
        for (let i = 0; i < count; i++) {
            const piece = document.createElement('div');
            const shape = shapes[Math.floor(Math.random() * shapes.length)];
            const color = colors[Math.floor(Math.random() * colors.length)];
            const size = Math.random() * 15 + 10;
            const left = Math.random() * 100;
            const delay = Math.random() * 5;
            const duration = (Math.random() * 3 + 4) * speedMultiplier;
            const rotation = Math.random() * 360;

            piece.className = 'confetti-piece';
            piece.style.cssText = `
        position: absolute;
        left: ${left}%;
        top: -${size + 20}px;
        width: ${size}px;
        height: ${size}px;
        opacity: 0.7;
        pointer-events: none;
        animation: confettiFall ${duration}s ease-in-out ${delay}s infinite;
        transform: rotate(${rotation}deg);
      `;

            // Shape styling
            if (shape === 'heart') {
                piece.innerHTML = `<svg viewBox="0 0 24 24" fill="${color}"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`;
            } else if (shape === 'star') {
                piece.innerHTML = `<svg viewBox="0 0 24 24" fill="${color}"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
            } else {
                piece.style.borderRadius = '50%';
                piece.style.backgroundColor = color;
            }

            container.appendChild(piece);
            confettiPieces.push(piece);
        }

        return () => {
            confettiPieces.forEach(piece => piece.remove());
        };
    }, [count, colors, shapes, speed]);

    return (
        <>
            <div
                ref={containerRef}
                className="absolute inset-0 overflow-hidden pointer-events-none z-0"
                aria-hidden="true"
            />
            <style>{`
        @keyframes confettiFall {
          0% {
            transform: translateY(0) rotate(0deg) scale(1);
            opacity: 0;
          }
          10% {
            opacity: 0.8;
          }
          50% {
            transform: translateY(50vh) rotate(180deg) scale(0.8);
          }
          90% {
            opacity: 0.6;
          }
          100% {
            transform: translateY(100vh) rotate(360deg) scale(0.6);
            opacity: 0;
          }
        }
        
        .confetti-piece svg {
          width: 100%;
          height: 100%;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
        }
      `}</style>
        </>
    );
}
